<template>
  <div class="home-navbar" :style="themeColor">
    <!-- 面包屑 -->
    <div class="navbar-breadcrumb">
      <!-- <el-breadcrumb separator=">">
        <el-breadcrumb-item v-for="(item, index) in routeList" :key="index">{{
          item.title
        }}</el-breadcrumb-item>
      </el-breadcrumb> -->
      <el-tabs
        v-model="editableTabsValue"
        type="card"
        @tab-click="handleTabClick"
        @tab-remove="handleTabsEdit"
        class="main-tabs"
        style="padding: 0 15px"
        v-if="!isStudent"
      >
        <el-tab-pane
          :key="item.name"
          v-for="item in editableTabs"
          :label="item.title"
          :name="item.name"
          :closable="item.closable"
        >
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 用户信息 -->
    <div class="navbar-userinfo">
      <!-- <div class="change-class">
        <el-dropdown trigger="click" @command="colorHandleCommand">
          <div class="change-class-color">
            <span class="el-dropdown-link">主题颜色<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="item"
                v-for="(item, index) in colorMenu"
                :key="index"
                ><div :style="{'background-color':item.color,'width':'50px','height':'20px'}">

                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </div>
        </el-dropdown>
      </div> -->
      <div class="userinfo-avatar" v-if="user.roleId != 1">
        <el-image style="width: 100%; height: 100%" :src="isStudent ? 'https://www.zlo.com.cn:8085/static/zhbx.png' : user.headPortrait" fit="cover">
          <div
            slot="error"
            class="image-slot"
            style="
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              background: #f5f7fa;
              color: #c0c4cc;
            "
          >
            <div>无图片</div>
          </div>
        </el-image>
      </div>
      <div class="change-class">
        <!-- 用户:管理员 -->
        <el-dropdown
          trigger="click"
          v-if="user.roleId == 1"
          @command="adminHandleCommand"
        >
          <div class="userinfo-name">
            <div class="text">{{ user.teacherName }}</div>
            <span>(管理员)</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :command="item"
              v-for="(item, index) in adminMenu"
              :key="index"
              >{{ item.label }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown
          trigger="click"
          v-if="isStudent"
          @command="adminHandleCommand"
        >
          <div class="userinfo-name">
            <div class="text">{{ user.studentName }}</div>
            <span>(学生)</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :command="item"
              v-for="(item, index) in studentMenu"
              :key="index"
              >{{ item.label }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>

        <!-- 用户:教师 -->
        <el-dropdown trigger="click" v-else @command="teacherHandleCommand">
          <div class="userinfo-name">
            <div class="text">{{ user.teacherName }}</div>
            <!-- <span>
              ({{
                classInfo.currentClass.isCharge == 1 ? "班主任" : "科任老师"
              }})
            </span> -->
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :command="item"
              v-for="(item, index) in teacherMenu"
              :key="index"
              >{{ item.label }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- <div class="userinfo-name">冯老师（班主任）</div> -->
      <!-- 切换班级 -->
      <!-- <div class="change-class" v-show="user.roleId != 1">
        <el-dropdown
          trigger="click"
          @command="handleCommand"
          v-if="classInfo.classList.length"
        >
          <div class="change-class-title">
            <div class="text">
              {{
                classInfo.currentClass.gradeName +
                classInfo.currentClass.className
              }}
            </div>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :command="{ item, index }"
              v-for="(item, index) in classInfo.classList"
              :key="index"
              >{{ item.gradeName + item.className }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div> -->
      <!--退出登录 -->
      <!-- <div class="logout-button">
        <el-button
          type="danger"
          size="mini"
          class="logout"
          @click="showLogoutConfirm"
          >退出登录</el-button
        >
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      routeList: [],
      classList: [],
      themeColor: { backgroundColor: "" },
      // colorMenu : [
      //   {
      //     color : "#fff"
      //   },
      //   {
      //     color : "red"
      //   },
      //   {
      //     color : "blue"
      //   }
      // ],
      studentMenu: [
        {
          label: "退出登录",
          path: "",
        },
      ],
      adminMenu: [
        {
          label: "修改密码",
          path: "/revise-password",
        },
        {
          label: "退出登录",
          path: "",
        },
      ],
      teacherMenu: [
        {
          label: "用户信息",
          path: "/userInfo",
        },
        {
          label: "修改密码",
          path: "/revise-password",
        },
        {
          label: "退出登录",
          path: "",
        },
      ],
    };
  },
  computed: {
    // 映射 tableTabs 模块的状态 (如果这里报错，说明模块未加载成功)
    ...mapState("tableTabs", ["editableTabs"]),

    // 用于 v-model 的计算属性（get/set）
    editableTabsValue: {
      get() {
        // 【核心修改】添加安全校验：确保 state.tableTabs 存在
        // 如果 state.tableTabs 不存在，返回默认的首页路径，防止运行时错误
        if (this.$store.state.tableTabs) {
          return this.$store.state.tableTabs.editableTabsValue;
        }
        return "/home-page";
      },
      set(val) {
        this.$store.commit("tableTabs/SET_ACTIVE_TAB", val);
      },
    },
    // 检测是否为学生
    isStudent() {
      return this.user.jobList && this.user.jobList.includes("学生");
    },
  },
  watch: {
    $route(to) {
      this.handleRouteList();

      // ... (安全校验不变)
      if (
        this.$store.state.tableTabs &&
        to.path !== this.$store.state.tableTabs.editableTabsValue
      ) {
        // 【修改点】查找当前路由的 title
        // 直接从 $route.meta 中获取 title
        const title = to.meta && to.meta.title ? to.meta.title : "新页面";

        // 添加新标签页
        this.$store.commit("tableTabs/ADD_TAB", {
          title: title, // 传入 $route.meta.title
          path: to.path,
        });
      }
    },
  },
  created() {
    // this.classList = this.classInfo.classList;
    this.handleRouteList();

    // 【修改点】初始化时根据当前路由添加初始标签页
    if (this.$route.path !== "/login" && this.$route.path !== "/404") {
      // 直接从 $route.meta 中获取 title
      const title =
        this.$route.meta && this.$route.meta.title ? this.$route.meta.title : "首页";

      if (this.$store.state.tableTabs) {
        this.$store.commit("tableTabs/ADD_TAB", {
          title: title, // 传入 $route.meta.title
          path: this.$route.path,
        });
      }
    }
  },
  methods: {
    // 【新增】点击标签页的处理：跳转路由
    handleTabClick(tab) {
      const path = tab.name;
      if (path !== this.$route.path) {
        this.$router.push(path);
      }
    },

    // 【新增】关闭标签页的处理
    handleTabsEdit(targetName) {
      // 首页不能关闭
      if (targetName === "/home-page") {
        return;
      }

      // 1. 调用 Vuex 移除标签页
      this.$store.commit("tableTabs/REMOVE_TAB", targetName);

      // 2. 如果关闭的是当前路由，则跳转到 Vuex 中新的激活页
      if (targetName === this.$route.path) {
        this.$router.push(this.editableTabsValue);
      }
    },
    ...mapActions("permission", ["resetLoginHandled"]),
    handleRouteList() {
      this.routeList = [];
      let routes = this.$route.matched;
      routes.forEach((item, index) => {
        this.routeList.push({
          path: item.path,
          title: item.meta.title,
        });
      });
    },
    showLogoutConfirm() {
      this.$confirm("是否退出当前账户?", "退出登录", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          this.get(this.$url.exitLogin).then((res) => {
            // 删除token并转到登录页面重新登录
            this.$store.dispatch("user/resetToken").then(() => {
              this.resetLoginHandled();
              this.$router.push("/login");
            });
          });
        })
        .catch(() => {});
    },
    routeUserInfo() {
      if (this.$route.path != "/userInfo") {
        this.$router.push("/userInfo");
      }
    },
    // 页面跳转
    routeJump(url) {
      // console.log(this.$route)
      if (this.$route.path != url) {
        this.$router.push(url);
      }
    },
    // 班级下拉菜单
    handleCommand(command) {
      let currentClass = this.classInfo.currentClass;
      let { item, index } = command;
      // 点击非当前选中班级时
      if (item.classId != currentClass.classId || item.gradeId != currentClass.gradeId) {
        // 切换班级
        this.$store.dispatch("classInfo/setCurrentClass", index);

        // console.log("this.$store", this.$store.state.classInfo.currentClass.className);
        this.$message.success("切换班级成功");
      }
    },
    // 主题颜色下拉菜单
    // colorHandleCommand(command){
    //   console.log(888,command);
    //   this.themeColor = {backgroundColor: command.color}
    // },
    // 管理员下拉菜单
    adminHandleCommand(command) {
      // console.log(command);
      if (command.label == "退出登录") {
        this.showLogoutConfirm();
      } else {
        // 跳转
        this.routeJump(command.path);
      }
    },
    // 教师下拉菜单
    teacherHandleCommand(command) {
      // console.log(command);
      if (command.label == "退出登录") {
        this.showLogoutConfirm();
      } else {
        // 跳转
        this.routeJump(command.path);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "./homeNavbar.scss";
</style>

<style scoped>
.confirm {
  background: #0066cc !important;
  border: none;
}
</style>
